module.exports = __webpack_public_path__ + "static/conflux-7902c3466d5fb3174ce413f03d7018a6.png";